import { render, staticRenderFns } from "./BulkUploads.vue?vue&type=template&id=075d2b41&"
import script from "./BulkUploads.vue?vue&type=script&lang=js&"
export * from "./BulkUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports